import { Box, Skeleton } from "@mui/material";
import {
  seatsCardSx,
  seatsHeadlineSx,
  seatsMeterColumnSx,
  seatsTrackSx,
} from "screens/Settings/Team/Team.styles";
import teamTokens from "screens/Settings/Team/Team.tokens";

const t = teamTokens;

/**
 * Placeholder for `SeatsCard` while the billing summary (and its planLimit
 * fallback) are still loading — same footprint as the real card so the table
 * below it doesn't jump once the numbers arrive.
 */
const SeatsCardSkeleton = () => (
  <Box sx={seatsCardSx}>
    <Box sx={seatsMeterColumnSx}>
      <Box sx={seatsHeadlineSx}>
        <Skeleton variant="text" width={40} height={18} />
        <Skeleton variant="text" width={170} height={16} />
        <Skeleton variant="text" width={130} height={14} sx={{ ml: "auto" }} />
      </Box>
      <Box sx={seatsTrackSx}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={t.size.seatTrackHeight}
          sx={{ borderRadius: t.radius.pill }}
        />
      </Box>
    </Box>
    <Skeleton variant="rounded" width={110} height={t.size.manageButtonHeight} />
  </Box>
);

export default SeatsCardSkeleton;
